import moment from "moment";
import { useTranslation } from "react-i18next";

export function ActivityDate({ date }: { date: string }) {
  const { t } = useTranslation();

  function formatDate(): string {
    let today = moment().format("YYYY-MM-DD");
    let yesterday = moment().subtract(1, "day").format("YYYY-MM-DD");

    if (date === today) {
      return t('today');
    } else if (date === yesterday) {
      return t('yesterday');
    } else if (moment(date).isSame(today, "year")) {
      return moment(date).format("DD MMMM");
    } else {
      return moment(date).format("DD MMMM YYYY");
    }
  }

  return (
    <div className="row align-items-center">
      <div className="col">
        <div className="separator"></div>
      </div>
      <div className="col-auto">
        <span className="separator-date">{formatDate()}</span>
      </div>
      <div className="col">
        <div className="separator"></div>
      </div>
    </div>
  );
}